// Предходният период за сравнителните чипове (Δ).
//
// Правилото е едно за всички справки: сравнява се РАВЕН ОТРЯЗЪК. Избраният
// период често още тече — „днес" в 11 сутринта е избран като 00:00–23:59, но
// се е случил само до 11:00. Сложи ли се срещу целия вчерашен ден, всяка Δ до
// вечерта показва срив, какъвто няма. Затова краят на предходния период се
// подрязва до същото изтекло време.
//
// Същото правило е и в BE-то за дашборда (`get_dashboard`, блокът `compare`) —
// двете страни трябва да казват едно и също.

import dayjs, { type Dayjs } from "dayjs";

export type PeriodRange = { start: Dayjs; end: Dayjs };

/**
 * Предходният период за `[start, end]`, отместен с толкова цели дни, колкото
 * е дълъг избраният, и подрязан до изтеклото време, ако периодът още тече.
 */
export const previousPeriodOf = (start: Dayjs, end: Dayjs): PeriodRange => {
  const now = dayjs();
  const days = end.diff(start, "day") + 1;
  const effectiveEnd = end.isAfter(now) ? now : end;
  return {
    start: start.subtract(days, "day"),
    end: effectiveEnd.subtract(days, "day"),
  };
};

/** Периодът още тече — Δ-тата сравняват отрязък, не цял период. */
export const isPeriodRunning = (end: Dayjs | null | undefined): boolean =>
  end ? end.isAfter(dayjs()) : false;
